import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ad824f52"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-footer" }

import { reactive, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import store from '@/store'

// eslint-disable-next-line no-undef
const formLabelWidth = '100px'

export default /*#__PURE__*/_defineComponent({
  __name: 'DownFileDialog',
  props: {
    title: {},
    url: {},
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props

// eslint-disable-next-line no-undef
const emit = __emit

// Internal reactive state
const form = reactive({
  url: props.url,
  email: ''
})

const dialogVisible = ref(props.modelValue)

const router = useRouter()

// Watchers
watch(() => props.modelValue, (newValue) => {
  dialogVisible.value = newValue
  form.url = props.url
}, { immediate: true })

watch(() => store.getters.userInfo, (newUserInfo) => {
  if (newUserInfo && newUserInfo.status) {
    // 如果用户已登录，更新邮箱
    form.email = newUserInfo.user_bind_info.email_verify_status ? newUserInfo.user_bind_info.email : ''
  } else {
    // 用户未登录时忽略或者清空邮箱
    form.email = ''
  }
}, { immediate: true })

watch(dialogVisible, (newVal) => {
  emit('update:modelValue', newVal)
})

// Methods
const goToBind = () => {
  router.push('/user/binding')
}

const handleClose = () => {
  dialogVisible.value = false
}

const confirmDialog = () => {
  handleClose()
}

return (_ctx: any,_cache: any) => {
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dialogVisible).value = $event)),
    "before-close": handleClose,
    title: "提示信息",
    width: "800"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_button, { onClick: handleClose }, {
          default: _withCtx(() => [
            _createTextVNode("Cancel")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          disabled: !form.email,
          type: "primary",
          onClick: confirmDialog
        }, {
          default: _withCtx(() => [
            _createTextVNode("Confirm")
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_text, { type: "danger" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.title), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_divider, null, {
        default: _withCtx(() => [
          _createTextVNode("请求下载到我的邮箱")
        ]),
        _: 1
      }),
      _createVNode(_component_el_space, { direction: "vertical" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form, { model: form }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                "label-width": formLabelWidth,
                label: "视频链接"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: form.url,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.url) = $event)),
                    autosize: { minRows: 2, maxRows: 4 },
                    class: "long-input",
                    readonly: "",
                    type: "textarea"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                "label-width": formLabelWidth,
                label: "邮箱地址"
              }, {
                default: _withCtx(() => [
                  (form.email)
                    ? (_openBlock(), _createBlock(_component_el_input, {
                        key: 0,
                        modelValue: form.email,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.email) = $event)),
                        class: "short-input",
                        readonly: ""
                      }, null, 8, ["modelValue"]))
                    : (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        type: "primary",
                        onClick: goToBind
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("绑定邮箱")
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})